import { Chip } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import { sportTypesCollRef } from "../../../utils/referencies";

const SportTypes: FC<any> = (props) => {
  const vendor = props.record;

  const [sportTypeIdList, setSportTypeIdList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchSportTypesId = async () => {
    setLoading(true);
    try {
      const snapshot = await sportTypesCollRef.get();
      if (!snapshot.empty) {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          name: doc.data().title.en,
        }));
        const filtered = data.filter((obj) => vendor.sportTypeIds.includes(obj.id));
        setSportTypeIdList(filtered);
      }
      setLoading(false);
    } catch (ex: any) {
      console.log(ex.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSportTypesId();
  }, []);

  return (
    <Loader loading={loading}>
      {sportTypeIdList.map((type) => {
        return <Chip key={type.id} label={type.name} style={{ margin: 2 }} />;
      })}
    </Loader>
  );
};

export default SportTypes;
